module.exports = __webpack_public_path__ + "static/media/selena-gomez-lose.ef19d1d5.jpg";